import { isChrome } from '@ui5/webcomponents-base/dist/Device';
import { MessageStrip, MessageStripDesign } from '@ui5/webcomponents-react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const UnsupportedBrowserWarning: React.FC = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(!isChrome());

  return isOpen ? (
    <MessageStrip
      design={MessageStripDesign.Warning}
      onClose={() => {
        setIsOpen(false);
      }}
    >
      {t('warning-message-browser-not-supported')}
    </MessageStrip>
  ) : null;
};
